import HomeBody from '../home/homeBody';
import HomeHero from '../home/homeHero';
import SEO from '../../../components/SEO';

export default function HomeView() {
  return (
    <>
      <SEO
        title="Home"
        description="Discover delicious homemade recipes at Evan's Oven. Browse our collection of easy-to-follow recipes for breakfast, lunch, dinner, and desserts."
        url="/home"
      />
      <HomeHero />
      <HomeBody />
      {/* <HomePlug /> */} {/* Uncomment to enable the plug section */}
    </>
  );
}
